import React from 'react';

const RatingChip = ({ value }) => {
  return <>{Array.isArray(value) ? value?.join(' - ') : value}</>;
};

export default RatingChip;
